import { useTranslation } from "react-i18next"
import { useMemo } from "react"
import { Heading } from "@oysterhr/ui"
import { OverviewStep } from "../../../../../components/OverviewStep"

export const AchFTEOverview = () => {
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/AchMethodOverview")

  const achFTESteps = useMemo(
    () => [
      {
        title: t("fte.steps.addPaymentMethod.title"),
        content: t("fte.steps.addPaymentMethod.content"),
      },
      {
        title: t("fte.steps.authorization.title"),
        content: t("fte.steps.authorization.content"),
      },
      {
        title: t("fte.steps.verification.title"),
        content: t("fte.steps.verification.content"),
      },
    ],
    [t],
  )

  return (
    <div className="mt-6">
      <Heading size="lg">{t("fte.header")}</Heading>
      <div className="mt-4 rounded-lg border-2 border-gray-200 p-4">
        <ul className="grid grid-cols-1 justify-items-start gap-4">
          {achFTESteps.map((step, index) => (
            <OverviewStep
              key={step.title}
              title={step.title}
              content={step.content}
              step={index + 1}
            />
          ))}
        </ul>
      </div>
    </div>
  )
}
